import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import passwordPolicyAxios from '../../axios/passwordPolicy'

export const fetchPasswordPolicy = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchPasswordPolicyStart())

    passwordPolicyAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchPasswordPolicySuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchPasswordPolicyFailed(error))
      })
  }
}

export const fetchPasswordPolicyStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_START
  }
}

export const fetchPasswordPolicySuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_SUCCESS,
    pagination,
    records
  }
}

export const fetchPasswordPolicyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyById = recordId => {
  return dispatch => {
    dispatch(fetchPasswordPolicyStart())
    passwordPolicyAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPasswordPolicyByIdSuccess(response.data.data))
          // dispatch(fetchPasswordPolicyOptions(response.data.data.appraisal_type_id))
        }
      })
      .catch(error => {
        dispatch(fetchPasswordPolicyFailed(error))
      })
  }
}

export const fetchPasswordPolicyByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedPasswordPolicyRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_PASSWORD_POLICY_RECORD
  }
}

export const createPasswordPolicy = (recordData, page) => {
  return dispatch => {
    dispatch(createPasswordPolicyStart())

    passwordPolicyAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Password Policy Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createPasswordPolicySuccess())
          dispatch(fetchPasswordPolicy(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Password Policy field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createPasswordPolicyFailed())
      })
  }
}

export const createPasswordPolicyStart = () => {
  return {
    type: actionTypes.CREATE_PASSWORD_POLICY_START
  }
}

export const createPasswordPolicySuccess = () => {
  return {
    type: actionTypes.CREATE_PASSWORD_POLICY_SUCCESS
  }
}

export const createPasswordPolicyFailed = () => {
  return {
    type: actionTypes.CREATE_PASSWORD_POLICY_FAILED
  }
}

export const updatePasswordPolicy = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updatePasswordPolicyStart())

    passwordPolicyAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Password Policy Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(updatePasswordPolicySuccess())
        dispatch(fetchPasswordPolicy(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Password Policy field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updatePasswordPolicyFailed())
      })
  }
}

export const updatePasswordPolicyStart = () => {
  return {
    type: actionTypes.UPDATE_PASSWORD_POLICY_START
  }
}

export const updatePasswordPolicySuccess = () => {
  return {
    type: actionTypes.UPDATE_PASSWORD_POLICY_SUCCESS
  }
}

export const updatePasswordPolicyFailed = () => {
  return {
    type: actionTypes.UPDATE_PASSWORD_POLICY_FAILED
  }
}

export const deletePasswordPolicy = (recordId, page) => {
  return dispatch => {
    dispatch(deletePasswordPolicyStart())
    passwordPolicyAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Password Policy Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deletePasswordPolicySuccess())
        dispatch(fetchPasswordPolicy(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deletePasswordPolicyFailed())
      })
  }
}

export const deletePasswordPolicyStart = () => {
  return {
    type: actionTypes.DELETE_PASSWORD_POLICY_START
  }
}

export const deletePasswordPolicySuccess = () => {
  return {
    type: actionTypes.DELETE_PASSWORD_POLICY_SUCCESS
  }
}

export const deletePasswordPolicyFailed = () => {
  return {
    type: actionTypes.DELETE_PASSWORD_POLICY_FAILED
  }
}

export const fetchPasswordPolicyMinimumAgeOptions = () => {
  return dispatch => {}
}

export const fetchPasswordPolicyMinimumAgeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyMinimumAgeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyMinimumAgeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyResetTicketMaxAgeOptions = () => {
  return dispatch => {}
}

export const fetchPasswordPolicyResetTicketMaxAgeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyResetTicketMaxAgeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyResetTicketMaxAgeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyHistoryCountOptions = () => {
  return dispatch => {}
}

export const fetchPasswordPolicyHistoryCountOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyHistoryCountOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyHistoryCountOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyMaximumAgeOptions = () => {
  return dispatch => {
    dispatch(fetchPasswordPolicyMaximumAgeOptionsStart())
  }
}

export const fetchPasswordPolicyMaximumAgeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyMaximumAgeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyMaximumAgeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyWarningTimeOptions = () => {
  return dispatch => {}
}

export const fetchPasswordPolicyWarningTimeOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyWarningTimeOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyWarningTimeOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyResetFailureCountOptions = () => {
  return dispatch => {}
}

export const fetchPasswordPolicyResetFailureCountOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyResetFailureCountOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyResetFailureCountOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyLockoutDurationOptions = () => {
  return dispatch => {}
}

export const fetchPasswordPolicyLockoutDurationOptionsStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START
  }
}

export const fetchPasswordPolicyLockoutDurationOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyLockoutDurationOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED,
    errorMessage
  }
}

export const fetchPasswordPolicyFilterPasswordPolicy = filter => {
  return dispatch => {
    dispatch(fetchPasswordPolicyFilterPasswordPolicyStart())
    passwordPolicyAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchPasswordPolicyFilterPasswordPolicySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchPasswordPolicyFilterPasswordPolicyFailed(error))
      })
  }
}

export const fetchPasswordPolicyFilterPasswordPolicyStart = () => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_START
  }
}

export const fetchPasswordPolicyFilterPasswordPolicySuccess = data => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_SUCCESS,
    data
  }
}

export const fetchPasswordPolicyFilterPasswordPolicyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_FAILED,
    errorMessage
  }
}
